import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';

export class ExportError extends ExpectedError {
  static override _class = 'ExportError';

  public constructor() {
    super('ExportError', { translationKey: 'EXPORT_ERROR' });
  }
}
